// src/pages/Home.tsx
import React, { useState } from 'react';
import { Logo } from '../components/logo';
import UserWidget from '../components/login_in_auth';
import { Link } from 'react-router-dom';
import fon from '../components/5.png';
import image10 from '../components/4.png';


export const Offer = () => {

  return (
    <div
      style={{
        position: 'relative',
        minHeight: '100vh',
        background: 'linear-gradient(314.56deg, #0A090C 0.38%, #1A092D 99.62%)',
        overflowX: 'hidden',
      }}
    >
      {/* Фоновое изображение */}
      <img
        src={fon}
        alt="Background"
        style={{
          position: 'absolute',
          width: 1207,
          height: 679,
          left: -226,
          top: 872,
          objectFit: 'cover',
          zIndex: 0,
          mixBlendMode: 'color-dodge',
          opacity: 0.2,
          
        }}
      />
  <button
    style={{
      position: 'relative',
      width: 243,
      height: 49,
      border: 'none',
      borderRadius: 24.5,
      top: 330,
      left: 180,
      background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
      color: '#fff',
      fontSize: 16,
      fontWeight: 500,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden',
    }}
  >
    <svg
      width="243"
      height="49"
      viewBox="0 0 243 49"
      fill="none"
      style={{ position: 'absolute', top: 0, left: 0 }}
    >
      <rect width="242.2" height="49" rx="24.5" fill="url(#paint0_linear)" />
      <path d="M30.6543 34.3281C29.196 34.3281 27.9062 34.0866 26.7852 33.6035C25.6641 33.1204 24.7845 32.4551 24.1465 31.6074C23.5085 30.7507 23.1895 29.7663 23.1895 28.6543V28.627C23.1895 27.7975 23.3717 27.041 23.7363 26.3574C24.11 25.6647 24.625 25.0814 25.2812 24.6074C25.9375 24.1243 26.694 23.7917 27.5508 23.6094V23.541C26.4479 23.222 25.5638 22.6797 24.8984 21.9141C24.2422 21.1393 23.9141 20.2279 23.9141 19.1797V19.1523C23.9141 18.1497 24.2012 17.2565 24.7754 16.4727C25.3496 15.6888 26.1426 15.0736 27.1543 14.627C28.1751 14.1712 29.3418 13.9434 30.6543 13.9434C31.9577 13.9434 33.1152 14.1712 34.127 14.627C35.1478 15.0736 35.9453 15.6888 36.5195 16.4727C37.0938 17.2565 37.3809 18.1497 37.3809 19.1523V19.1797C37.3809 20.2279 37.0527 21.1393 36.3965 21.9141C35.7402 22.6797 34.8561 23.222 33.7441 23.541V23.6094C34.61 23.7917 35.3665 24.1243 36.0137 24.6074C36.6699 25.0814 37.1803 25.6647 37.5449 26.3574C37.9186 27.041 38.1055 27.7975 38.1055 28.627V28.6543C38.1055 29.7663 37.7865 30.7507 37.1484 31.6074C36.5195 32.4551 35.64 33.1204 34.5098 33.6035C33.3887 34.0866 32.1035 34.3281 30.6543 34.3281ZM30.6543 31.8672C31.4928 31.8672 32.2311 31.7214 32.8691 31.4297C33.5163 31.138 34.0221 30.737 34.3867 30.2266C34.7604 29.707 34.9473 29.1146 34.9473 28.4492V28.4219C34.9473 27.7565 34.765 27.1641 34.4004 26.6445C34.0358 26.125 33.5299 25.7194 32.8828 25.4277C32.2357 25.127 31.4928 24.9766 30.6543 24.9766C29.8066 24.9766 29.0592 25.127 28.4121 25.4277C27.765 25.7194 27.2591 26.125 26.8945 26.6445C26.5299 27.1641 26.3477 27.7565 26.3477 28.4219V28.4492C26.3477 29.1146 26.5299 29.707 26.8945 30.2266C27.2682 30.737 27.7786 31.138 28.4258 31.4297C29.0729 31.7214 29.8158 31.8672 30.6543 31.8672ZM30.6543 22.502C31.3835 22.502 32.0215 22.3743 32.5684 22.1191C33.1243 21.8548 33.5573 21.4948 33.8672 21.0391C34.1862 20.5742 34.3457 20.0456 34.3457 19.4531V19.4258C34.3457 18.8242 34.1862 18.2956 33.8672 17.8398C33.5573 17.3841 33.1243 17.0286 32.5684 16.7734C32.0124 16.5091 31.3743 16.377 30.6543 16.377C29.9251 16.377 29.2826 16.5091 28.7266 16.7734C28.1706 17.0286 27.7331 17.3841 27.4141 17.8398C27.1042 18.2956 26.9492 18.8242 26.9492 19.4258V19.4531C26.9492 20.0456 27.1042 20.5742 27.4141 21.0391C27.7331 21.4948 28.166 21.8548 28.7129 22.1191C29.2689 22.3743 29.916 22.502 30.6543 22.502ZM41.9336 34L50.6973 16.9238V16.8555H40.2793V14.2715H53.7324V16.9375L45.1465 34H41.9336ZM60.3086 24.1562C59.4336 24.1562 58.6816 23.9557 58.0527 23.5547C57.4238 23.1445 56.9408 22.5612 56.6035 21.8047C56.2663 21.0482 56.0977 20.1595 56.0977 19.1387V19.125C56.0977 18.0951 56.2663 17.2064 56.6035 16.459C56.9408 15.7025 57.4238 15.1237 58.0527 14.7227C58.6816 14.3125 59.4336 14.1074 60.3086 14.1074C61.1836 14.1074 61.9355 14.3125 62.5645 14.7227C63.1934 15.1237 63.6719 15.7025 64 16.459C64.3372 17.2064 64.5059 18.0951 64.5059 19.125V19.1387C64.5059 20.1595 64.3372 21.0482 64 21.8047C63.6719 22.5612 63.1934 23.1445 62.5645 23.5547"/>
      <defs>
        <linearGradient id="paint0_linear" x1="0" y1="24.5" x2="242.2" y2="24.5" gradientUnits="userSpaceOnUse">
          <stop stopColor="#6D1D7D" />
          <stop offset={1} stopColor="#5F0BE8" />
        </linearGradient>
      </defs>
    </svg>
    <span style={{ position: 'relative', zIndex: 1 , fontSize: 28,}}>87% confidence</span>
  </button>
  <div
    style={{
  position: 'absolute',
  width: 649,
  height: 432,
  left: 696,
  top: 205,
  borderRadius: 50,
  background: 'rgba(85, 35, 170, 0.1)',
  backdropFilter: 'blur(48px)',
  WebkitBackdropFilter: 'blur(48px)',
  boxShadow: `
    /* outer drops */
    -11.15px -10.39px 48px -12px rgba(0,0,0,.15),
    -1.86px  -1.73px  12px -8px  rgba(0,0,0,.15),

    /* inner highlight (Plus-lighter emulation) */
    inset 2.01px 1.87px 8.64px rgba(255,255,255,.15),
    inset 1.08px 1.00px 4.32px rgba(255,255,255,.15)
  `,
  backgroundBlendMode: 'plus-lighter',   /* keeps tint soft */
  mixBlendMode: 'normal',
}}
  >
    <div style={{ position: 'relative', width: 456, height: 84 }}>
    {/* текст */}
    <div
      style={{
        position: 'absolute',
        width: 400,
        right: 660,
        top: 600,
        fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
        fontWeight: 510,
        fontSize: 64,
        lineHeight: '76px',
        color: '#FFFFFF',
        userSelect: 'none',
      }}
    >
      Special Offer
    </div>

    {/* линия */}
    <div
      style={{
        position: 'absolute',
        left: -600,
        top: 700,
        bottom: 0,
        width: 359,
        height: 8,
        borderRadius: 50,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
      }}
    />
  </div>
  <div style={{ position: 'absolute', width: 1202, height: 482,top:-80,left:50}}>
    {/* ----- заголовки ----- */}
    <div
      style={{
        position: 'absolute',
        left: 55,
        top: 826,
        fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
        fontWeight: 510,
        fontSize: 40,
        lineHeight: '48px',
        color: '#FFFFFF',
      }}
    >
      Unlock Full Access
    </div>

    <div
      style={{
        position: 'absolute',
        left: 55,
        top: 877,
        width: 359,
        height: 8,
        borderRadius: 50,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
      }}
    />

    <div
      style={{
        position: 'absolute',
        left: 55,
        top: 894,
        width: 405,
        height: 29,
        fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
        fontWeight: 510,
        fontSize: 24,
        lineHeight: '29px',
        color: 'rgba(255, 255, 255, 0.6)',
      }}
    >
      After your free analyses, you’ll need to:
    </div>

    {/* ----- карточка 1 ----- */}
    <div
      style={{
        position: 'absolute',
        left: 55,
        top: 961,
        width: 547,
        height: 143,
      }}
    >
      {/* фон */}
      <div
        style={{
          position: 'absolute',
          left: 50,
          top: 0,
          width: 497,
          height: 143,
          borderRadius: 50,
          background: 'rgba(127, 56, 243, 0.2)',
          backgroundBlendMode: 'plus-lighter',
          mixBlendMode: 'normal',
          boxShadow: `
            -11.1504px -10.392px 48px -12px rgba(0,0,0,.15),
            -1.8584px -1.732px 12px -8px rgba(0,0,0,.15),
            inset 2.00707px 1.87056px 8.64px rgba(255,255,255,.15),
            inset 1.07787px 1.00456px 4.32px rgba(255,255,255,.15)
          `,
          backdropFilter: 'blur(4.88px)',
          WebkitBackdropFilter: 'blur(4.88px)',
        }}
      />

      {/* иконка */}
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 33,
          height: 33,
          borderRadius: '50%',
          background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
          mixBlendMode: 'normal',
          boxShadow: `
            -10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,.15),
            -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,.15),
            inset 1.93181px 1.80041px 8.316px rgba(255,255,255,.126),
            inset 1.09553px 1.02101px 4.158px rgba(255,255,255,.126)
          `,
          backdropFilter: 'blur(6.822px)',
          WebkitBackdropFilter: 'blur(6.822px)',
          transform: 'matrix(-1, 0, 0, 1, 0, 0)',
        }}
      />

      {/* текст */}
      <div
        style={{
          position: 'absolute',
          left: 90,
          top: 22,
          width: 416,
          height: 99,
          fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
          fontWeight: 510,
          fontSize: 28,
          lineHeight: '33px',
          color: '#FFFFFF',
        }}
      >
        Open an account with one of our <span style={{ color: 'transparent', background: "linear-gradient(90deg, #6D1D7D -10%, #5F0BE8 150%)", WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>recommended brokers</span> via the link
        provided.
      </div>
    </div>

    {/* ----- карточка 2 ----- */}
    <div
      style={{
        position: 'absolute',
        left: 55,
        top: 1144,
        width: 547,
        height: 143,
      }}
    >
      {/* фон */}
      <div
        style={{
          position: 'absolute',
          left: 50,
          top: 0,
          width: 497,
          height: 143,
          borderRadius: 50,
          background: 'rgba(127, 56, 243, 0.2)',
          backgroundBlendMode: 'plus-lighter',
          mixBlendMode: 'normal',
          boxShadow: `
            -11.1504px -10.392px 48px -12px rgba(0,0,0,.15),
            -1.8584px -1.732px 12px -8px rgba(0,0,0,.15),
            inset 2.00707px 1.87056px 8.64px rgba(255,255,255,.15),
            inset 1.07787px 1.00456px 4.32px rgba(255,255,255,.15)
          `,
          backdropFilter: 'blur(4.88px)',
          WebkitBackdropFilter: 'blur(4.88px)',
        }}
      />

      {/* иконка */}
      <div
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          width: 33,
          height: 33,
          borderRadius: '50%',
          background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
          mixBlendMode: 'normal',
          boxShadow: `
            -10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,.15),
            -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,.15),
            inset 1.93181px 1.80041px 8.316px rgba(255,255,255,.126),
            inset 1.09553px 1.02101px 4.158px rgba(255,255,255,.126)
          `,
          backdropFilter: 'blur(6.822px)',
          WebkitBackdropFilter: 'blur(6.822px)',
          transform: 'matrix(-1, 0, 0, 1, 0, 0)',
        }}
      />

      {/* текст */}
      <div
        style={{
          position: 'absolute',
          left: 90,
          top: 22,
          width: 416,
          height: 99,
          fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
          fontWeight: 510,
          fontSize: 28,
          lineHeight: '33px',
          color: '#FFFFFF',
        }}
      >
        Maintain a <span style={{ color: 'transparent', background: "linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 200%)", WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>minimum deposit</span> of <span style={{ color: 'transparent', background: "linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 300%)", WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>$50</span> to continue accessing AI trade plans.
      </div>
    </div>
  </div>
  <div style={{ position: 'relative', width: 1125.9, height: 108,top:1200,right:545}}>
    {/* ---------- основная плашка ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: 1125.9,
        height: 97.2,
        borderRadius: 48.6,
        background: 'rgba(99, 48, 193, 0.3)',
        backgroundBlendMode: 'plus-lighter',
        mixBlendMode: 'normal',
        boxShadow: `
          -6.42263px -5.98579px 27.648px -6.912px rgba(0,0,0,.15),
          -1.07044px -0.997632px 6.912px -4.608px rgba(0,0,0,.15),
          inset 1.07044px 0.997632px 4.608px rgba(255,255,255,.15),
          inset 0.535219px 0.498816px 2.304px rgba(255,255,255,.15)
        `,
        backdropFilter: 'blur(1.152px)',
        WebkitBackdropFilter: 'blur(1.152px)',
      }}
    />

    {/* ---------- левая активная полоса ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 0.45,
        top: 0,
        width: 509,
        height: 97,
        borderRadius: 48.6,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
        mixBlendMode: 'normal',
        boxShadow: `
          -10.5973px -9.87656px 45.6192px -11.4048px rgba(0,0,0,.15),
          -1.76622px -1.64609px 11.4048px -7.6032px rgba(0,0,0,.15),
          inset 1.76622px 1.64609px 7.6032px rgba(255,255,255,.15),
          inset 0.883112px 0.823046px 3.8016px rgba(255,255,255,.15)
        `,
        backdropFilter: 'blur(1.9008px)',
        WebkitBackdropFilter: 'blur(1.9008px)',
      }}
    />

    {/* ---------- левый белый кружок ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 0.45,
        top: 0,
        width: 96,
        height: 97,
        borderRadius: 48.6,
        background: '#FFFFFF',
        mixBlendMode: 'normal',
        boxShadow: `
          -10.5973px -9.87656px 45.6192px -11.4048px rgba(0,0,0,.15),
          -1.76622px -1.64609px 11.4048px -7.6032px rgba(0,0,0,.15),
          inset 1.76622px 1.64609px 7.6032px rgba(255,255,255,.15),
          inset 0.883112px 0.823046px 3.8016px rgba(255,255,255,.15)
        `,
        backdropFilter: 'blur(1.9008px)',
        WebkitBackdropFilter: 'blur(1.9008px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* иконка графика */}
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.24971 34.65C7.34221 34.65 6.56561 34.3271 5.91991 33.6814C5.27421 33.0357 4.95081 32.2586 4.94971 31.35V8.24996C4.94971 7.34246 5.27311 6.56586 5.91991 5.92016C6.56671 5.27446 7.34331 4.95106 8.24971 4.94996H21.4497C21.9172 4.94996 22.3094 5.10836 22.6262 5.42516C22.943 5.74196 23.1008 6.13356 23.0997 6.59996C23.0986 7.06636 22.9402 7.45851 22.6245 7.77641C22.3088 8.09431 21.9172 8.25216 21.4497 8.24996H8.24971V31.35H31.3497V18.15C31.3497 17.6825 31.5081 17.2909 31.8249 16.9752C32.1417 16.6595 32.5333 16.5011 32.9997 16.5C33.4661 16.4989 33.8583 16.6573 34.1762 16.9752C34.4941 17.2931 34.6519 17.6847 34.6497 18.15V31.35C34.6497 32.2575 34.3269 33.0346 33.6812 33.6814C33.0355 34.3282 32.2583 34.6511 31.3497 34.65H8.24971ZM13.1997 16.5C12.7322 16.5 12.3406 16.6584 12.0249 16.9752C11.7092 17.292 11.5508 17.6836 11.5497 18.15V26.4C11.5497 26.8675 11.7081 27.2596 12.0249 27.5764C12.3417 27.8932 12.7333 28.0511 13.1997 28.05C13.6661 28.0489 14.0583 27.8905 14.3762 27.5748C14.6941 27.2591 14.8519 26.8675 14.8497 26.4V18.15C14.8497 17.6825 14.6913 17.2909 14.3745 16.9752C14.0577 16.6595 13.6661 16.5011 13.1997 16.5ZM19.7997 11.55C19.3322 11.55 18.9406 11.7084 18.6249 12.0252C18.3092 12.342 18.1508 12.7336 18.1497 13.2V26.4C18.1497 26.8675 18.3081 27.2596 18.6249 27.5764C18.9417 27.8932 19.3333 28.0511 19.7997 28.05C20.2661 28.0489 20.6583 27.8905 20.9762 27.5748C21.2941 27.2591 21.4519 26.8675 21.4497 26.4V13.2C21.4497 12.7325 21.2913 12.3409 20.9745 12.0252C20.6577 11.7095 20.2661 11.5511 19.7997 11.55ZM26.3997 21.45C25.9322 21.45 25.5406 21.6084 25.2249 21.9252C24.9092 22.242 24.7508 22.6336 24.7497 23.1V26.4C24.7497 26.8675 24.9081 27.2596 25.2249 27.5764C25.5417 27.8932 25.9333 28.0511 26.3997 28.05C26.8661 28.0489 27.2583 27.8905 27.5762 27.5748C27.8941 27.2591 28.0519 26.8675 28.0497 26.4V23.1C28.0497 22.6325 27.8913 22.2409 27.5745 21.9252C27.2577 21.6095 26.8661 21.4511 26.3997 21.45ZM28.0497 11.55H26.3997C25.9322 11.55 25.5406 11.3916 25.2249 11.0748C24.9092 10.758 24.7508 10.3664 24.7497 9.89996C24.7486 9.43356 24.907 9.04196 25.2249 8.72516C25.5428 8.40836 25.9344 8.24996 26.3997 8.24996H28.0497V6.59996C28.0497 6.13246 28.2081 5.74086 28.5249 5.42516C28.8417 5.10946 29.2333 4.95106 29.6997 4.94996C30.1661 4.94886 30.5583 5.10726 30.8762 5.42516C31.1941 5.74306 31.3519 6.13466 31.3497 6.59996V8.24996H32.9997C33.4672 8.24996 33.8594 8.40836 34.1762 8.72516C34.493 9.04196 34.6508 9.43356 34.6497 9.89996C34.6486 10.3664 34.4902 10.7585 34.1745 11.0764C33.8588 11.3943 33.4672 11.5522 32.9997 11.55H31.3497V13.2C31.3497 13.6675 31.1913 14.0596 30.8745 14.3764C30.5577 14.6932 30.1661 14.8511 29.6997 14.85C29.2333 14.8489 28.8417 14.6905 28.5249 14.3748C28.2081 14.0591 28.0497 13.6675 28.0497 13.2V11.55Z" fill="url(#paint0_linear_31_416)"/>
      <defs>
      <linearGradient id="paint0_linear_31_416" x1="4.94971" y1="19.8" x2="34.6497" y2="19.8" gradientUnits="userSpaceOnUse">
      <stop stop-color="#6D1D7D"/>
      <stop offset="1" stop-color="#5F0BE8"/>
      </linearGradient>
      </defs>
      </svg>
    </div>

    {/* ---------- текст «Start Chart Analysis» ---------- */}
    
    <Link
          to="/ai"
          style={{
            position: 'absolute',
            left: 99.45,
            top: 27,
            width: 364,
            height: 44,
            fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
            fontWeight: 510,
            fontSize: 36.4954,
            lineHeight: '44px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#FFFFFF',
            textDecoration: 'none', // Убираем подчеркивание
            cursor: 'pointer', // Добавляем указатель при наведении
          }}
        >
          Start Chart Analysis
        </Link>

    {/* ---------- правая активная полоса ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 619.45,
        top: 1,
        width: 506,
        height: 96,
        borderRadius: 48,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
        mixBlendMode: 'normal',
        boxShadow: `
          -10.5973px -9.87656px 45.6192px -11.4048px rgba(0,0,0,.15),
          -1.76622px -1.64609px 11.4048px -7.6032px rgba(0,0,0,.15),
          inset 1.76622px 1.64609px 7.6032px rgba(255,255,255,.15),
          inset 0.883112px 0.823046px 3.8016px rgba(255,255,255,.15)
        `,
        backdropFilter: 'blur(1.9008px)',
        WebkitBackdropFilter: 'blur(1.9008px)',
      }}
    />

    {/* ---------- правый белый кружок ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 1029.45,
        top: 1,
        width: 96,
        height: 96,
        borderRadius: 48,
        background: '#FFFFFF',
        mixBlendMode: 'normal',
        boxShadow: `
          -10.5973px -9.87656px 45.6192px -11.4048px rgba(0,0,0,.15),
          -1.76622px -1.64609px 11.4048px -7.6032px rgba(0,0,0,.15),
          inset 1.76622px 1.64609px 7.6032px rgba(255,255,255,.15),
          inset 0.883112px 0.823046px 3.8016px rgba(255,255,255,.15)
        `,
        backdropFilter: 'blur(1.9008px)',
        WebkitBackdropFilter: 'blur(1.9008px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      {/* иконка ссылки */}
      <svg width="37" height="25" viewBox="0 0 37 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.7815 0.119995C6.8486 0.119723 4.96961 0.771496 3.436 1.97422C1.90238 3.17695 0.799848 4.86341 0.299399 6.77202C-0.201051 8.68063 -0.0714431 10.7047 0.668119 12.5304C1.40768 14.356 2.71586 15.8811 4.38976 16.8692C4.93954 17.1943 5.59312 17.2827 6.20671 17.1152C6.51053 17.0322 6.79539 16.8889 7.04502 16.6934C7.29465 16.4978 7.50417 16.254 7.66162 15.9757C7.81906 15.6974 7.92134 15.3901 7.96263 15.0714C8.00391 14.7527 7.98338 14.4288 7.90222 14.1182C7.82106 13.8077 7.68085 13.5164 7.4896 13.2612C7.29835 13.006 7.0598 12.7919 6.78758 12.6309C6.02609 12.1822 5.43078 11.4892 5.09403 10.6592C4.75728 9.8293 4.69793 8.90894 4.9252 8.041C5.15247 7.17306 5.65363 6.40608 6.35091 5.85911C7.0482 5.31214 7.9026 5.01577 8.7815 5.016H18.36C19.3319 5.015 20.2708 5.37663 21.0005 6.03302C21.7302 6.68942 22.2005 7.59545 22.3231 8.58113C22.4458 9.5668 22.2124 10.5643 21.6667 11.3866C21.121 12.2088 20.3006 12.7993 19.3594 13.0471C18.7442 13.2089 18.2171 13.614 17.894 14.1732C17.571 14.7324 17.4785 15.3998 17.6368 16.0287C17.7952 16.6576 18.1914 17.1965 18.7384 17.5267C19.2854 17.857 19.9383 17.9515 20.5535 17.7897C22.62 17.2405 24.42 15.9406 25.617 14.1331C26.814 12.3256 27.326 10.1342 27.0572 7.9688C26.7883 5.80339 25.7572 3.81223 24.1565 2.36767C22.5558 0.923114 20.4952 0.12408 18.36 0.119995H8.7815ZM17.3606 11.6729C17.9758 11.511 18.5029 11.106 18.826 10.5468C19.149 9.98762 19.2415 9.32017 19.0832 8.69126C18.9248 8.06235 18.5286 7.52351 17.9816 7.19327C17.4346 6.86303 16.7817 6.76845 16.1665 6.93033C14.1 7.47951 12.3 8.77941 11.103 10.5869C9.90599 12.3944 9.39403 14.5858 9.66284 16.7512C9.93165 18.9166 10.9628 20.9078 12.5635 22.3523C14.1642 23.7969 16.2248 24.5959 18.36 24.6H27.9385C29.8714 24.6003 31.7504 23.9485 33.284 22.7458C34.8176 21.543 35.9202 19.8566 36.4206 17.948C36.921 16.0394 36.7914 14.0153 36.0519 12.1896C35.3123 10.364 34.0041 8.83886 32.3302 7.85078C31.7805 7.52572 31.1269 7.43724 30.5133 7.60481C29.8997 7.77238 29.3764 8.18227 29.0584 8.7443C28.7404 9.30633 28.6539 9.97448 28.8178 10.6017C28.9817 11.229 29.3826 11.764 29.9324 12.0891C30.6939 12.5377 31.2892 13.2308 31.626 14.0608C31.9627 14.8907 32.0221 15.8111 31.7948 16.679C31.5675 17.5469 31.0664 18.3139 30.3691 18.8609C29.6718 19.4078 28.8174 19.7042 27.9385 19.704H18.36C17.3881 19.705 16.4492 19.3434 15.7195 18.687C14.9898 18.0306 14.5195 17.1245 14.3969 16.1389C14.2742 15.1532 14.5076 14.1556 15.0533 13.3334C15.599 12.5112 16.4194 11.9207 17.3606 11.6729Z" fill="url(#paint0_linear_31_430)"/>
      <defs>
      <linearGradient id="paint0_linear_31_430" x1="0" y1="12.36" x2="36.72" y2="12.36" gradientUnits="userSpaceOnUse">
      <stop stop-color="#6D1D7D"/>
      <stop offset="1" stop-color="#5F0BE8"/>
      </linearGradient>
      </defs>
      </svg>
    </div>

    {/* ---------- текст «Link Broker Account» ---------- */}
    <Link
      to="/affiliate"
      style={{
        position: 'absolute',
        left: 622.45,
        top: 27,
        width: 416,
        height: 44,
        fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
        fontWeight: 510,
        fontSize: 36.4954,
        lineHeight: '44px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#FFFFFF',
        textDecoration: 'none', // Убираем подчеркивание
        cursor: 'pointer',
      }}
    >Link Broker Account</Link>

    {/* ---------- декоративные палочки ---------- */}
    {/* горизонтальная */}
    <div
      style={{
        position: 'absolute',
        left: -25,
        top: -31,
        width: 84,
        height: 12,
        borderRadius: 50,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
      }}
    />
    {/* вертикальная */}
    <div
      style={{
        position: 'absolute',
        left: -18,
        top: -31,
        width: 84,
        height: 12,
        borderRadius: 50,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
        transform: 'rotate(90deg)',
        transformOrigin: '0 0',
      }}
    />
    {/* нижняя горизонтальная (перевернутая) */}
    <div
      style={{
        position: 'absolute',
        left: 1070,
        top: 120,
        width: 84,
        height: 12,
        borderRadius: 50,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
        transform: 'rotate(-180deg)',
      }}
    />
    {/* правая вертикальная (перевернутая) */}
    <div
      style={{
        position: 'absolute',
        left: 1145,
        top: 130,
        width: 84,
        height: 12,
        borderRadius: 50,
        background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
        transform: 'rotate(-90deg)',
        transformOrigin: '0 0',
      }}
    />
  </div>
  <div style={{ position: 'relative', width: 568, height: 404 ,right: 700,top: -200}}>
    {/* ---------- фоновая пластина ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 97,
        top: 849,
        width: 463,
        height: 308,
        borderRadius: 50,
        background: 'rgba(127, 56, 243, 0.15)',
        backgroundBlendMode: 'plus-lighter',
        mixBlendMode: 'normal',
        boxShadow: `
          -11.1504px -10.392px 48px -12px rgba(0,0,0,.15),
          -1.8584px -1.732px 12px -8px rgba(0,0,0,.15),
          inset 2.00707px 1.87056px 8.64px rgba(255,255,255,.15),
          inset 1.07787px 1.00456px 4.32px rgba(255,255,255,.15)
        `,
        backdropFilter: 'blur(4.88px)',
        WebkitBackdropFilter: 'blur(4.88px)',
      }}
    />

    {/* ---------- заголовок ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 143,
        top: 875,
        width: 342,
        height: 96,
        fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
        fontWeight: 510,
        fontSize: 40,
        lineHeight: '48px',
        color: '#FFFFFF',
      }}
    >
      Start with 3<br></br> <span style={{ color: 'transparent', background: "linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)", WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Free</span> Analyses
    </div>

    {/* ---------- подзаголовок ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 143,
        top: 984,
        width: 259,
        height: 141,
        fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
        fontWeight: 510,
        fontSize: 24,
        lineHeight: '29px',
        color: 'rgba(255, 255, 255, 0.6)',
      }}
    >
      Try it out with three completely free chart analyses to see the value for
      yourself.
    </div>

    {/* ---------- подарочная иконка (gift) ---------- */}
    


    {/* ---------- декоративный кружок ---------- */}
    <div
      style={{
        position: 'absolute',
        left: 472,
        top: 817,
        width: 96,
        height: 96,
        borderRadius: '50%',
        background: 'linear-gradient(90deg, rgba(109, 29, 125, 0.8) 0%, rgba(95, 11, 232, 0.8) 100%)',
        mixBlendMode: 'normal',
        boxShadow: `
          -10.0354px -9.3528px 43.2px -10.8px rgba(0,0,0,.15),
          -1.67256px -1.5588px 10.8px -7.2px rgba(0,0,0,.15),
          inset 1.93181px 1.80041px 8.316px rgba(255,255,255,.126),
          inset 1.09553px 1.02101px 4.158px rgba(255,255,255,.126)
        `,
        backdropFilter: 'blur(6.822px)',
        WebkitBackdropFilter: 'blur(6.822px)',
        transform: 'matrix(-1, 0, 0, 1, 0, 0)',
      }}
    >
    <svg style={{position:"relative",top:20,left:22}} width="52" height="63" viewBox="0 0 52 63" fill="none" xmlns="http://www.w3.org/2000/svg" >
    <path  fill-rule="evenodd" clip-rule="evenodd" d="M17.5 0.666687C19.1079 0.666599 20.6974 1.00863 22.1629 1.67007C23.6284 2.33151 24.9364 3.29721 26 4.50302C27.0636 3.29721 28.3716 2.33151 29.8371 1.67007C31.3026 1.00863 32.8921 0.666599 34.5 0.666687H35.9167C37.0438 0.666687 38.1248 1.11445 38.9219 1.91148C39.7189 2.70851 40.1667 3.78952 40.1667 4.91669V6.33335C40.1667 8.39885 39.6142 10.334 38.6508 12H45.8333C47.3362 12 48.7776 12.597 49.8403 13.6597C50.903 14.7225 51.5 16.1638 51.5 17.6667V26.1667C51.5 27.1614 51.2381 28.1385 50.7408 28.9999C50.2434 29.8614 49.5281 30.5767 48.6667 31.074V46C48.6667 48.2544 47.7711 50.4164 46.1771 52.0104C44.583 53.6045 42.421 54.5 40.1667 54.5H11.8333C9.57899 54.5 7.41699 53.6045 5.82293 52.0104C4.22887 50.4164 3.33333 48.2544 3.33333 46V31.074C2.47191 30.5767 1.75658 29.8614 1.25923 28.9999C0.761873 28.1385 0.500025 27.1614 0.5 26.1667V17.6667C0.5 16.1638 1.09702 14.7225 2.15973 13.6597C3.22243 12.597 4.66377 12 6.16667 12H13.3492C12.3553 10.2769 11.8326 8.32254 11.8333 6.33335V4.91669C11.8333 3.78952 12.2811 2.70851 13.0781 1.91148C13.8752 1.11445 14.9562 0.666687 16.0833 0.666687H17.5ZM43 31.8334H28.8333V48.8334H40.1667L40.4982 48.8135C41.1306 48.7389 41.7195 48.4535 42.1698 48.0032C42.6201 47.5529 42.9056 46.964 42.9802 46.3315L43 46V31.8334ZM23.1667 31.8334H9V46C9.00009 46.694 9.25488 47.3638 9.71603 47.8824C10.1772 48.401 10.8126 48.7323 11.5018 48.8135L11.8333 48.8334H23.1667V31.8334ZM45.8333 17.6667H28.8333V26.1667H45.8333V17.6667ZM23.1667 17.6667H6.16667V26.1667H23.1667V17.6667ZM17.5 6.33335C17.5 7.83625 18.097 9.27759 19.1597 10.3403C20.2224 11.403 21.6638 12 23.1667 12C23.1667 10.4971 22.5696 9.05579 21.5069 7.99308C20.4442 6.93038 19.0029 6.33335 17.5 6.33335ZM34.5 6.33335C32.9971 6.33335 31.5558 6.93038 30.4931 7.99308C29.4304 9.05579 28.8333 10.4971 28.8333 12C30.3362 12 31.7776 11.403 32.8403 10.3403C33.903 9.27759 34.5 7.83625 34.5 6.33335Z" fill="white" fill-opacity="0.8"/>
    </svg>
    </div>
  </div>
    

    {/* Title */}
    <h2
      style={{
        position: 'absolute',
        width: 400,
        height: 152,
        right: 47,
        top: 31,
        margin: 0,
        fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
        fontWeight: 510,
        fontSize: 64,
        lineHeight: '76px',
        textAlign: 'right',
        color: '#FFFFFF',
        letterSpacing: '-0.02em',
      }}
    >
      Trade <span style={{ color: 'transparent', background: 'linear-gradient(to right, #6D1D7D, #5F0BE8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Smarter</span> Not <span style={{ color: 'transparent', background: 'linear-gradient(to right, #6D1D7D, #5F0BE8)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Harder</span>
    </h2>

    {/* Subtitle */}
    <p
      style={{
        position: 'absolute',
        width: 494,
        height: 141,
        right: 52,
        top: 216,
        margin: 0,
        fontFamily: `'SF Pro', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif`,
        fontWeight: 510,
        fontSize: 24,
        lineHeight: '29px',
        textAlign: 'right',
        color: 'rgba(255, 255, 255, 0.6)',
        letterSpacing: '-0.01em',
      }}
    >
      Upload your trading chart from any platform and let our AI instantly
      analyze patterns, levels, and market structure. Receive actionable trade
      plans with entry points, stop loss, and take profit levels—no guru
      required.
    </p>
  </div>
      <img
        src={image10}
        alt="Background"
        style={{
          position: 'absolute',
          width: 1404,
          height: 790,
          left: 0,
          top: 94,
          objectFit: 'cover',
          zIndex: 1,
          mixBlendMode: 'color-dodge',
          opacity: 0.5,
          
        }}
      />

      {/* Основной контент */}
      <div style={{ position: 'relative', zIndex: 1, maxWidth: 1440, margin: '0 auto' }}>
        <Logo />
        <UserWidget></UserWidget>
      </div>
    </div>
  );
};